//@ts-nocheck

import { Dispatch, SetStateAction, useState } from "react";
import { motion } from "framer-motion";
import { SiNike, SiAtlassian, SiDribbble, SiGrubhub, SiKaggle, SiSlack } from "react-icons/si";
import OneIcon from "../../assets/1.svg";
import TwoIcon from "../../assets/2.png";
const testimonials = [
  {
    Icon: TwoIcon,
    title: "The Credit Barrier",
    description:
     "Small businesses have long been locked out of essential funding due to unclear and outdated means to navigate business credit systems, leaving them struggling to access the resources they need to grow.",

  },
  {
    Icon: SiAtlassian,
    title: "The Ripple Effect",
    description:
      "Without reliable credit access, 80% of small businesses face stagnation, limiting job creation and deepening economic inequality—disproportionately affecting minority- and women-owned enterprises.",

  },
  {
    Icon: SiDribbble,
    title: "Lessons from the Past",
    description:
      "The 2008 financial crisis revealed the devastating impact of limited credit access, with over 3.5 million job losses. Today, inefficiencies in business credit monitoring continue to hinder post-pandemic recovery.",
 
  },
  {
    Icon: SiGrubhub,
    title: "Current Vulnerabilities",
    description:
      "Cybersecurity breaches, like the Krispy Kreme incident, and public access to business data have increased the risk of fraud and unauthorized credit applications, leaving businesses more exposed than ever.",

  },
  {
    Icon: SiKaggle,
    title: "The Funding Bottleneck",
    description:
      "Unclear means to navigate business credit reports and scores leave 75% of small businesses struggling to secure funding, stalling growth and innovation.",

  },
  {
    Icon: SiSlack,
    title: "The Awareness Gap",
    description:
      "Over 50% of small business owners lack awareness of business credit, leading to missed opportunities, financial missteps, and costly borrowing.",
    
  },
];

const StackedCardTestimonials = () => {
  const [selected, setSelected] = useState(0);

  return (
    <section className="bg-white py-16 px-4 md:px-8 grid items-center grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-4 overflow-hidden">
      <div className="p-4">
        <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
          Problem Statement
        </h3>
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
          America's Business Credit Crisis
        </h3>
        <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">
          The Barrier Blocking Small Business Growth
        </h3>

        <p className="text-base md:text-lg lg:text-xl text-black font-semibold my-4">
          Without clear and fair credit access, small businesses face barriers to funding and growth. FuteurCred simplifies Business Credit Navigation, empowering you with actionable insights and real-time tools to unlock your potential.
        </p>
        <SelectBtns
          numTracks={testimonials.length}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <Cards
        testimonials={testimonials}
        setSelected={setSelected}
        selected={selected}
      />
    </section>
  );
};

const SelectBtns = ({ numTracks, setSelected, selected }: { numTracks: number, setSelected: Dispatch<SetStateAction<number>>, selected: number }) => {
  return (
    <div className="flex gap-1 mt-8">
      {Array.from(Array(numTracks).keys()).map((n) => {
        return (
          <button
            key={n}
            onClick={() => setSelected(n)}
            className="h-1.5 w-full bg-slate-300 relative"
          >
            {selected === n ? (
              <motion.span
                className="absolute top-0 left-0 bottom-0 bg-slate-950"
                initial={{
                  width: "0%",
                }}
                animate={{
                  width: "100%",
                }}
                transition={{
                  duration: 5,
                }}
                onAnimationComplete={() => {
                  setSelected(selected === numTracks - 1 ? 0 : selected + 1);
                }}
              />
            ) : (
              <span
                className="absolute top-0 left-0 bottom-0 bg-slate-950"
                style={{
                  width: selected > n ? "100%" : "0%",
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};

const Cards = ({ testimonials, selected, setSelected }: { testimonials: any[], selected: number, setSelected: Dispatch<SetStateAction<number>> }) => {
  return (
    <div className="p-4 relative h-[400px] md:h-[450px] lg:h-[500px] shadow-xl">
      {testimonials.map((t, i) => {
        return (
          <Card
            {...t}
            key={i}
            position={i}
            selected={selected}
            setSelected={setSelected}
          />
        );
      })}
    </div>
  );
};

const Card = ({
  Icon,
  title,
  description,
  position,
  selected,
  setSelected,
}: {
  Icon: any,
  title: string,
  description: string,
  position: number,
  selected: number,
  setSelected: Dispatch<SetStateAction<number>>
}) => {
  const scale = position <= selected ? 1 : 1 + 0.015 * (position - selected);
  const offset = position <= selected ? 0 : 95 + (position - selected) * 3;
  const background = position % 2 ? "black" : "white";
  const color = position % 2 ? "white" : "black";

  return (
    <motion.div
      initial={false}
      style={{
        zIndex: position,
        transformOrigin: "left bottom",
        background,
        color,
      }}
      animate={{
        x: `${offset}%`,
        scale,
      }}
      whileHover={{
        translateX: position === selected ? 0 : -3,
      }}
      transition={{
        duration: 0.25,
        ease: "easeOut",
      }}
      onClick={() => setSelected(position)}
      className="absolute top-0 left-0 w-full min-h-full p-6 md:p-8 lg:p-12 cursor-pointer flex flex-col justify-between"
    >
      
      <h2 className="text-2xl md:text-4xl font-bold text-center mt-20">{title}</h2>
      <p className="text-sm md:text-base lg:text-lg font-bold mt-10 mb-40 text-center">
        {description}
      </p>
    </motion.div>
  );
};

export default StackedCardTestimonials;

